import * as React from "react";

import {observable} from "mobx";
import {observer} from "mobx-react";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {SwitchContainer} from "shared/controls/animation/SwitchContainer";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import {RNCheckBox} from "shared/controls/SingleInputs/RNCheckBox/RNCheckBox";
import {StoreBase} from "shared/utilities/Store/StoreBase";
import {SpinnerButton} from "shared/controls/SpinnerButton";


declare let rednaoAdminEmail:any;
@observer
export class DeactivationDialog extends React.Component<DeactivationDialogProps, DeactivationDialogState> {
    static defaultProps: Partial<DeactivationDialogProps> = {};
    public OnDispose:()=>void;
    public store:DeactivationStore;
    constructor(props: DeactivationDialogProps) {
        super(props);
        this.state = {
            IsOpen:true,
            IsSubmitting:false
        };
        this.store=new DeactivationStore().Merge();
    }

    public render() {
        console.log(this.store.EmailMe);
        return (
            <Dialog IsOpen={this.state.IsOpen} Title={"Quick Feedback"} Styles={{width:600}}  AfterOnClose={()=>this.OnDispose()} FooterArea={this.GetFooter()}>
                <div className={'rednao'}>
                    <h2 style={{margin:'0 0 5px 0'}}>If you don't mind, could you tell me why you are deactivating?</h2>
                    <div className={'rednaoItem '+(this.store.DeactivationReason=='Did not work'?'active':'')} style={{padding:2}}>
                        <div className={'rncontrol'} style={{display:'flex',alignItems:'center',marginTop:10}}>
                            <input onChange={(e)=>{this.store.DeactivationReason='Did not work'}} checked={this.store.DeactivationReason=="Did not work"} id={'rednao-didnt-work'} type={'radio'} radioGroup={'group'} value={"Didn't work"}/>
                            <label style={{fontWeight:'normal', margin:0,cursor:'pointer',marginLeft:5}} htmlFor="rednao-didnt-work">The plugin didn't work</label>
                        </div>
                        <SwitchContainer style={{display:'block',width:'100%'}}>
                            {   this.store.DeactivationReason=='Did not work'&&
                            <React.Fragment>
                                <div className={'rncontrol'}>
                                    <RNTextInput<DeactivationStore> Required={true} placeholder={'Sorry for that, could you tell me what didn\'t work?'}  Label={''} Store={this.store} PropertyName={"PluginDidnWorkReason"}  type={'text'}/>
                                </div>
                                <div>
                                    <div style={{display:'flex',alignItems:'center'}}>
                                        <RNCheckBox<DeactivationStore> style={{display:'inline-block',margin:0}} Store={this.store} Label={'Email me if this issue can be solved'} PropertyName={"EmailMe"}/>
                                        {
                                            this.store.EmailMe&&
                                            <RNTextInput<DeactivationStore> Required={true} Store={this.store} PropertyName={'Email'} Label={''}
                                                                            style={{display: 'inline-block', width: 250, marginLeft: 5,marginBottom:0}}
                                                                            placeholder={'Your email'}/>
                                        }


                                    </div>
                                </div>
                            </React.Fragment>
                            }
                        </SwitchContainer>
                    </div>

                    <div className={'rednaoItem '+(this.store.DeactivationReason=='Couldnt do what i wanted'?'active':'')} style={{padding:2}}>
                        <div className={'rncontrol'} style={{display:'flex',alignItems:'center',marginTop:10}}>
                            <input onChange={(e)=>{this.store.DeactivationReason='Couldnt do what i wanted'}} checked={this.store.DeactivationReason=="Couldnt do what i wanted"} id={'rednao-couldnt-do'} type={'radio'} radioGroup={'group'} value={"Didn't work"}/>
                            <label style={{fontWeight:'normal', margin:0,cursor:'pointer',marginLeft:5}} htmlFor="rednao-couldnt-do">I couldn't do what i wanted</label>
                        </div>
                        <SwitchContainer style={{display:'block',width:'100%'}}>
                            {   this.store.DeactivationReason=='Couldnt do what i wanted'&&
                            <React.Fragment>
                                <div className={'rncontrol'}>
                                    <RNTextInput<DeactivationStore> Store={this.store} placeholder={'could you tell me what you were trying to do?'} Required={true} type={'text'} Label={''} PropertyName={'WhatIWantedReason'}/>
                                </div>
                                <div>
                                    <div style={{display:'flex',alignItems:'center'}}>
                                        <RNCheckBox<DeactivationStore> style={{display:'inline-block',margin:0}} Store={this.store} Label={'Email me if this can be done'} PropertyName={"EmailMe"}/>
                                        {
                                            this.store.EmailMe&&
                                            <RNTextInput<DeactivationStore> Required={true} Store={this.store} PropertyName={'Email'} Label={''}
                                                                            style={{display: 'inline-block', width: 250, marginLeft: 5,marginBottom:0}}
                                                                            placeholder={'Your email'}/>
                                        }


                                    </div>
                                </div>
                            </React.Fragment>
                            }
                        </SwitchContainer>
                    </div>


                    <div className={'rednaoItem '+(this.store.DeactivationReason=='Other'?'active':'')} style={{padding:2}}>
                        <div className={'rncontrol'} style={{display:'flex',alignItems:'center',marginTop:10}}>
                            <input onChange={(e)=>{this.store.DeactivationReason='Other'}} checked={this.store.DeactivationReason=="Other"} id={'rednao-other'} type={'radio'} radioGroup={'group'} value={"Didn't work"}/>
                            <label style={{fontWeight:'normal', margin:0,cursor:'pointer',marginLeft:5}} htmlFor="rednao-other">Other</label>
                        </div>

                        <SwitchContainer style={{display:'block',width:'100%'}}>
                            {   this.store.DeactivationReason=='Other'&&
                            <React.Fragment>
                                <div className={'rncontrol'}>
                                    <RNTextInput<DeactivationStore> Store={this.store} placeholder={'Could you explain a little more the problem please?'} type={'text'} Label={''} PropertyName={'OtherReason'} Required={true}/>
                                </div>
                            </React.Fragment>
                            }
                        </SwitchContainer>
                    </div>

                    <div className={'rncontrol'} style={{display:'flex',alignItems:'center',marginTop:10}}>
                        <input onChange={(e)=>{this.store.DeactivationReason='Temporary'}} checked={this.store.DeactivationReason=="Temporary"} id={'rednao-temporary'} type={'radio'} radioGroup={'group'} value={"Didn't work"}/>
                        <label style={{fontWeight:'normal', margin:0,cursor:'pointer',marginLeft:5}} htmlFor="rednao-temporary">It's a temporary deactivation. I will activate it later.</label>
                    </div>


                </div>
            </Dialog>
        )
    }

    private GetFooter() {
        return(
            <React.Fragment>

                <button className={'rnbtn rnbtn-info'} onClick={()=>{window.location.href=(window as any).wpformDeactivationLink;}}>Skip & Deactivate</button>
                <SpinnerButton disabled={this.store.DeactivationReason==''} Icon={null} IsBusy={this.state.IsSubmitting} OnClick={()=>this.Submit()} className={'rnbtn rnbtn-primary'}>Submit & Deactivate</SpinnerButton>
                <button onClick={()=>this.setState({IsOpen:false})} className={'rnbtn rnbtn-danger'}>Cancel</button>
            </React.Fragment>
        )
    }

    private Submit() {
        if(this.store.DeactivationReason=="Temporary")
        {
            window.location.href=(window as any).wpformDeactivationLink;
            return;
        }

        if(this.store.Validate()){
            let reason=this.store.DeactivationReason;
            let reasonDetail='';
            switch(reason)
            {
                case "Did not work":
                    reasonDetail=this.store.PluginDidnWorkReason;
                    break;
                case "Couldnt do what i wanted":
                    reasonDetail=this.store.WhatIWantedReason;
                    break;
                case "Other":
                    reasonDetail=this.store.OtherReason;
                    break;
            }

            this.setState({IsSubmitting:true});
            jQuery.post('https://wooinvoice.rednao.com/wp-admin/admin-ajax.php',{
                reason:reason,
                plugin:'wpform',
                details:reasonDetail,
                email:this.store.EmailMe?this.store.Email:'',
                action:'rednao_woo_deactivation_reason'
            });

            setTimeout(()=>{
                window.location.href=(window as any).wpformDeactivationLink;
            });
        }


    }
}
declare let wooPDFInvoiceDeactivationLink:any;
export class DeactivationStore extends StoreBase{
    @observable DeactivationReason:|""|'Did not work'|'Couldnt do what i wanted'|'Temporary'|'Other';
    @observable Email:string;
    @observable EmailMe:boolean;
    @observable PluginDidnWorkReason:string;
    @observable WhatIWantedReason:string;
    @observable OtherReason:string;


    protected LoadDefaultValues() {
        this.DeactivationReason='';
        this.PluginDidnWorkReason='';
        this.Email='';
        this.EmailMe=false;
        this.WhatIWantedReason='';
        this.OtherReason='';
    }

}

//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface DeactivationDialogProps {

}

interface DeactivationDialogState {
    IsOpen:boolean;
    IsSubmitting:boolean;
}

//#endregion "My Region"